import * as React from "react"
import { SectionWrapperProps } from "./types"
import { Flex, Box } from "@chakra-ui/react"
import useWindowSize from "../../../../hooks/useWindowSize"
import { Tooltip } from "../../../common/tooltip"

export const SectionWrapper: React.FC<SectionWrapperProps> = ({
  children,
  switchConfig,
  tip,
  isSmallWidth
}) => {
  const { screenSize } = useWindowSize()
  return (
    <Tooltip label={tip}>
      <Flex
        pos="relative"
        alignItems="center"
        justifyContent="center"
        background={"rgba(255, 255, 255, 0.15)"}
        cursor={"pointer"}
        onClick={switchConfig}
        marginLeft={
          screenSize.width < 350 ? "0rem" : isSmallWidth ? "0.2rem" : "0.5rem"
        }
        marginRight={isSmallWidth ? "0.2rem" : "0.5rem"}
        height={isSmallWidth ? "1.5rem" : "3rem"}
        width={isSmallWidth ? "1.5rem" : "3rem"}
        borderRadius="9999px"
        padding={isSmallWidth ? "0.25rem" : "0.5rem"}
      >
        <Box pos="relative" width="100%" height="100%">
          <Flex
            position="absolute"
            top="0"
            left="0"
            width="100%"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            {children}
          </Flex>
        </Box>
      </Flex>
    </Tooltip>
  )
}
